/* eslint-disable no-unused-vars */ // TODO: Remove this blanket disable
// Enums that represent general app-wide values

// Which way to display a button that can appear in multiple modes
export enum ButtonMode {
  BUTTON = "BUTTON",
  ICON = "ICON",
}
